export default __webpack_public_path__ + "static/987-2a0308cd45388894261da471c301c6e6.gif";